import axios from 'axios'
import APIService from '@/api/services/APIService/APIServiceImpl'
import PaymentServiceV1 from '@/api/services/PaymentService/PaymentServiceV1'

import { PaymentInitResponseDTO } from "../../../../../requests-module"



export default class PaymentServiceV1Impl
    extends APIService
    implements PaymentServiceV1 {
    constructor() {
        const serviceUrl = `https://stynzl8ay7.execute-api.eu-west-3.amazonaws.com/dev` // TODO switch url
        super(serviceUrl)
    }

    async init(token: string, locale: string, provider?: string): Promise<PaymentInitResponseDTO> {
        const params: { [key: string]: string } = {
            locale: locale.replaceAll("-", "_"),
        }
        if (provider) params["provider"] = provider
        const headers = {
            ...this.getDefaultHeaders(),
        }
        const url = `${this.getServiceUrl()}/booking/payment/${token}`
        const { data } = await axios.get(url, {
            params,
            headers,
        })
        return data
    }

}